/* eslint-disable @typescript-eslint/no-unused-vars */
/* global LKF_KONF */
import {
  Konf,
  getApiHost as _getApiHost,
  getAppUrl as _getAppUrl,
  getClientId as _getClientId,
  getConfigField as _getConfigField,
  getCookieDomain as _getCookieDomain,
  getCookieDomainDeprecated as _getCookieDomainDeprecated,
  getVisaHost as _getVisaHost,
} from "./lib";

declare const LKF_KONF: Konf;

export function getConfigField<T>(
  field: string | string[],
  defaultValue: T
): T {
  return _getConfigField(LKF_KONF, field, defaultValue);
}

export function getClientId(client: string) {
  return _getClientId(LKF_KONF, client);
}

export function getVisaHost() {
  return _getVisaHost(LKF_KONF);
}

export function getAppUrl(client: string) {
  return _getAppUrl(LKF_KONF, client);
}

export function getApiHost(api: string) {
  return _getApiHost(LKF_KONF, api);
}

export function getCookieDomain() {
  return _getCookieDomain(LKF_KONF);
}

export function getCookieDomainDeprecated() {
  return _getCookieDomainDeprecated(LKF_KONF);
}
